import type { IconName } from "components/Icon";

import { Paper, Stack } from "@mui/material";
import { DynamicEchartsChart } from "components/chart/DynamicChartMemoized";

import { withEnergyAnalysisChartStyle } from "../lib/chartStyle";
import { EnergyAnalysisSectionTitle } from "./EnergyAnalysisSectionTitle";

type EnergyAnalysisInsightChartProps = {
  className?: string;
  height?: string;
  iconName?: IconName;
  option: object;
  title: string;
};

const increaseHeight = (height: string) => {
  const remHeight = /^(\d+(?:\.\d+)?)rem$/.exec(height);
  return remHeight ? `${Number(remHeight[1]) * 1.1}rem` : height;
};

export const EnergyAnalysisInsightChart = ({
  className = "w-full",
  height = "24rem",
  iconName = "Piechart",
  option,
  title,
}: EnergyAnalysisInsightChartProps) => {
  const chartHeight = increaseHeight(height);
  const chartOption = withEnergyAnalysisChartStyle(option);
  return (
    <Paper className={`${className} overflow-hidden !p-4`}>
      <Stack className="w-full flex-col items-stretch gap-3">
        <EnergyAnalysisSectionTitle iconName={iconName} title={title} />
        <div className="w-full shrink-0 [&_h3]:hidden" style={{ height: chartHeight }}>
          <DynamicEchartsChart
            className="h-full w-full"
            option={chartOption}
            secondYAxisRange={undefined}
            style={{ height: "100%" }}
            title={undefined}
            tooltip={undefined}
            xAxisRange={undefined}
            yAxisRange={undefined}
          />
        </div>
      </Stack>
    </Paper>
  );
};
